import queryString from 'query-string';

/**
 * @description adds `clientId` info from Google Analytics into `deep_link` parameter from an url
 * @param url {String}
 * @param clientId {String}
 * @returns {String} if the input url have `deep_link` parameter, adds clientId on that;
 *                   otherwise returns the same url
 */
export function addClientIdToDeepLink(url, clientId) {
  const [urlBase, urlParams] = url.split('?');
  const params = queryString.parse(urlParams);

  if (!params.deep_link) {
    return url;
  }

  const [deepLink, deepLinkParams] = params.deep_link.split('?');

  if (deepLinkParams) {
    const deepLinkParamsObject = {
      ...queryString.parse(deepLinkParams),
      clientid: clientId
    };

    const newParams = {
      ...params,
      deep_link: `${deepLink}?${queryString.stringify(deepLinkParamsObject)}`
    };

    return `${urlBase}?${queryString.stringify(newParams)}`;
  }

  params.deep_link += `?clientid=${clientId}`;

  return `${urlBase}?${queryString.stringify(params)}`;
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/core/deep-link.js
 **/